<template>
    <div>

        <trax-ui-form :id="id" :form="form" :action="action" :bus="bus" :source="source" :target="target">

            <trax-ui-toggle :text="lang.polaris.account.admin_account" :disabled="selfEdit==1 || !canManage" v-model="form.admin">
            </trax-ui-toggle>

            <trax-ui-select v-model="selected_entity_type" :options="entity_types_select" 
                :placeholder="lang.polaris.account.account_type" v-show="!form.admin" 
                v-if="entity_types_select.length" :disabled="selfEdit==1 || !canManage">
            </trax-ui-select>

            <trax-ui-select v-model="selected_organization" :options="organizations_select" 
                :unselected="lang.polaris.account.no_organization" v-show="!form.admin && organizations_select.length"
                :disabled="selfEdit==1 || !canManage">
            </trax-ui-select>

            <trax-ui-select v-model="selected_entity" :options="entities_select" 
                :unselected="lang.polaris.account.no_entity" v-show="!form.admin && entities_select.length"
                :disabled="selfEdit==1 || !canManage">
            </trax-ui-select>

            <trax-ui-select v-model="form.rights_level" :options="rights_levels_select"
                v-show="!form.admin && organizations_select.length" :disabled="selfEdit==1 || !canManage">
            </trax-ui-select>

            <trax-ui-select v-model="form.role_id" :options="roles_select"
                v-show="!form.admin" 
                v-if="roles_select.length" :disabled="selfEdit==1 || !canManage">
            </trax-ui-select>

            <trax-ui-select v-model="form.user_function" :options="user_functions_select" 
                :unselected="lang.polaris.account.no_function" v-if="user_functions_select.length"
                 v-show="!form.admin" :disabled="selfEdit==1 || !canManage">
            </trax-ui-select>

            <trax-ui-toggle :text="lang.polaris.account.occasional_learner" v-model="form.occasional_learner"
                v-show="!form.admin && !isLearnerRole" :disabled="selfEdit==1 || !canManage">
            </trax-ui-toggle>

            <p class="pl-3 mb-0 trax-text-muted" v-show="!form.admin && !isLearnerRole">
                <small>{{ lang.polaris.account.occasional_learner_help }}</small>
            </p>

        </trax-ui-form>

    </div>
</template>

<script>
    export default {
    
        props: {
            selfEdit: null,
            manageEntities: null,
            source: {default: '1'},
            target: {default: 'final'}
        },
        
        data: function() {
            return {
                id: 'trax-account-user-edit',
                lang: lang,
                user: user,

                entities_endpoint: app_url+"trax/api/front/entities",
                roles_select: data.roles_select,
                learner_role_id: data.learner_role_id,
                entity_types_select: data.entity_types_select,
                rights_levels_select: data.rights_levels_select,
                user_functions_select: data.user_functions_select,
                organizations_select: [],
                entities_select: [],

                loaded: false,
                organizations_loaded: false,
                entities_loaded: false,
                loading_finished: false,

                selected_entity_type: '',
                selected_organization: '',
                selected_entity: '',

                form: {
                    admin: '',
                    entity_type: '',
                    role_id: '',
                    entity_id: '',
                    subentity_id: '',
                    rights_level: '',
                    user_function: '',
                    occasional_learner: false
                },
                errors: {},
                action: {
                    align: 'right',
                    label: lang.polaris.form.save
                },
                bus: this.$bus
            }
        },

        computed: {

            // The supervisors don't change the rights of an account.
            canManage() {
                return this.user.admin || this.user.permissions['user.manage'] ? true : false;
            },

            // A learner account is a learner already: the mark is for the other roles.
            isLearnerRole() {
                return this.learner_role_id && this.form.role_id == this.learner_role_id;
            }
        },

        created: function() {
            var that = this;

            this.bus.$on(that.id+'-data', function(data) {
                that.selectData(data);
                if (!that.manageEntities) return;
                that.loadOrganizations();
                if (that.form.entity_id) that.loadEntities();
                else that.entities_loaded = true;
            });

            this.bus.$on(that.id+'-errors', function(errors) {
                that.errors = errors;
            });
        },

        watch: {

            selected_entity_type: function (value) {
                if (!this.loaded) return;
                this.form.entity_type = value;
                this.selected_organization = '';
                this.loadOrganizations();
                this.updateRightsLevel();
            },

            selected_organization: function (value) {
                if (!this.loaded) return;
                this.form.entity_id = value;
                this.selected_entity = '';
                this.loadEntities();
                this.updateRightsLevel();
            },

            selected_entity: function (value) {
                if (!this.loaded) return;
                this.form.subentity_id = value;
                this.updateRightsLevel();
            },

            loading_finished: function (value) {
                this.loaded = value;
            }
        },

        methods: {

            updateRightsLevel() {
                this.form.rights_level = this.form.subentity_id ? 'entity' : 
                    (this.form.entity_id ? 'organization' : 'global');
            },

            loadOrganizations() {
                var that = this;
                axios.get(that.entities_endpoint, {
                    params: {
                        filters: {
                            type: that.form.entity_type,
                            parent_id: {$exists: false}
                        }
                    }})
                    .then(function (response) {
                        var select = response.data.data.map(function(item, index) {
                            return {name: item.name, value: item.id};
                        });
                        that.organizations_select = select;
                        that.organizations_loaded = true;
                        that.checkLoaded();
                    })
            },

            loadEntities() {
                var that = this;
                axios.get(that.entities_endpoint, {
                    params: {
                        filters: {
                            type: that.form.entity_type,
                            parent_id: that.form.entity_id
                        }
                    }})
                    .then(function (response) {
                        var select = response.data.data.map(function(item, index) {
                            return {name: item.name, value: item.id};
                        });
                        that.entities_select = select;
                        that.entities_loaded = true;
                        that.checkLoaded();
                    })
            },

            checkLoaded() {
                if (this.loaded || !this.organizations_loaded || !this.entities_loaded) return;
                this.selected_entity_type = this.form.entity_type;
                this.selected_entity = this.form.subentity_id;
                this.selected_organization = this.form.entity_id;
                this.loading_finished = true;
            },

            selectData(data) {
                this.data = data;
                for (var index in this.form) {
                    this.form[index] = data[index];
                }
            }
        }
    }
</script>
